import { Component, Vue, Prop } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import { ExamSession } from '@/shared/model/exam-session.model';

@Component({
  mixins: [Vue2Filters.mixin],
})
export default class SessionCard extends Vue {
  @Prop()
  public examSession: ExamSession;
  @Prop()
  public selectedSession: ExamSession;

  //computed properties
  get remainingPlaces(): number {
    return this.examSession.nbPlaceMax - this.examSession.nbPlacePrises;
  }
  get hasDetails(): boolean {
    if (this.hasInfosComplement || this.hasAccessUrl) {
      return true;
    } else {
      return false;
    }
  }
  get hasAccessUrl(): boolean {
    if (this.examSession.examCenter.accessUrl !== '' && this.examSession.examCenter.accessUrl !== null) {
      return true;
    } else {
      return false;
    }
  }
  get hasInfosComplement(): boolean {
    if (this.examSession.examCenter.infosComplement !== '' && this.examSession.examCenter.infosComplement !== null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Check visibility of element in page
   * @param element
   */
  public checkVisibility(element) {
    let isVisible: boolean;
    if (element.offsetWidth || element.offsetHeight || element.getClientRects().length) {
      isVisible = true;
    } else {
      isVisible = false;
    }
    return isVisible;
  }

  /**
   * Scroll to inscription form
   */
  public startScroll() {
    let VueScrollTo = require('vue-scrollto');
    let options = {
      container: 'body',
      easing: 'ease',
      offset: 0,
      force: true,
      cancelable: true,
      x: false,
      y: true,
    };
    const element = document.getElementById('inscription');
    // Fix for Internet Explorer : check visibility of div with ID 'inscription' before scrolling to this element
    // If element is not visible yet, set timeout before scrolling down
    if (!this.checkVisibility(element)) {
      window.setTimeout(() => {
        VueScrollTo.scrollTo(element, 500, options);
      }, 500);
    } else {
      VueScrollTo.scrollTo(element, 500, options);
    }
  }

  /**
   * Emit the clicked session to parent component
   * @param examSession session click on cards
   */
  public setSelectedSession(examSession) {
    this.$emit('clickOnCard', examSession);
  }

  /**
   * Emit the session selected for registration to parent component
   * @param examSession
   */
  public setSessionToRegister(examSession) {
    this.$emit('clickOnRegister', examSession);
    this.startScroll();
  }
}
